module.exports = __webpack_public_path__ + "static/parent-528549c9f4db244a26f4b6025f15f1d8.svg";